var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
    _c("div", {
      key: _vm.illustrationUrl,
      staticClass: "illustration-header",
      domProps: { innerHTML: _vm._s(_vm.coloredSVG) }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }